import { render, staticRenderFns } from "./CompanyFilters.vue?vue&type=template&id=2059a90b&scoped=true&"
import script from "./CompanyFilters.vue?vue&type=script&lang=ts&"
export * from "./CompanyFilters.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyFilters.vue?vue&type=style&index=0&id=2059a90b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2059a90b",
  null
  
)

export default component.exports